// ============================================================================
// VARIABLE HELPERS
// ============================================================================

// Auto-fill logic - simple and centralized
export function getAutoValue(varName: string, selectedClient?: any): string {
  if (!selectedClient) return "";

  switch (varName) {
    case "client.name":
      return selectedClient?.name || selectedClient?.company_name || "";
    case "client.email":
      return selectedClient?.email || "";
    case "client.phone":
      return selectedClient?.phone || "";
    case "client.company":
      return selectedClient?.company_name || "";
    case "date.today":
      return new Date().toLocaleDateString();
    case "date.time":
      return new Date().toLocaleTimeString();
    default:
      return "";
  }
}
